<script setup lang="ts">
import type { EquipItemType } from '@/types/equip'
import EquipInfo from '@/views/item/components/EquipInfo.vue'
import { equipCollection } from '@/core/equip'
import { getEquipName } from '@/utils/equip'
import { useUserStore } from '@/stores/modules/user'
import { dayjs } from 'element-plus'
import { Lock, CircleCheck } from '@element-plus/icons-vue'
import { socketEmitAsync } from '@/utils/web-socket'
import { useCommonStore } from '@/stores/modules/common'
import { computed } from 'vue'

const commonStore = useCommonStore()
const userStore = useUserStore()

const emits = defineEmits(['close'])

const day2EquipInfo: EquipItemType = {
  ...equipCollection[38009],
  id: '2',
  equipId: 38009,
  quality: 'legend',
  reinforcedLevel: 0,
  isLock: false,
}
const day7EquipInfo: EquipItemType = {
  ...equipCollection[38023],
  id: '7',
  equipId: 38023,
  quality: 'legend',
  reinforcedLevel: 0,
  isLock: false,
}

const checkInRewardList = [
  { text: '💰 200,000' },
  { equipInfo: day2EquipInfo },
  { text: '💎 500' },
  { text: '3 <span class="info">强化保护券</span>' },
  { text: '💎 500' },
  { text: '1 <span class="legend">升星石</span>' },
  { equipInfo: day7EquipInfo },
]

const userCreatedDay = dayjs().diff(dayjs(userStore.created).format('YYYY-MM-DD 00:00:00'), 'day')
const receiveEndIndex = userCreatedDay >= 6 ? 7 : userCreatedDay + 1
async function handleReceive() {
  await socketEmitAsync({ type: 'receiveNoviceCheckIn' })
  userStore.noviceCheckInIndex = receiveEndIndex
  if (receiveEndIndex === 7) emits('close')
  commonStore.getMailList()
}

const canReceive = computed(() => receiveEndIndex > userStore.noviceCheckInIndex)
</script>

<template>
  <div class="novice-check-in">
    <div class="reward">
      <div class="border-wrap" v-for="(item, index) of checkInRewardList" :key="index">
        <h3>第 {{ index + 1 }} 日</h3>
        <template v-if="item.text">
          <span class="affix" v-html="item.text"></span>
        </template>
        <template v-else-if="item.equipInfo">
          <el-popover placement="bottom" width="300px" trigger="click">
            <template #reference>
              <CommonBtn size="small">
                <span class="legend" v-html="getEquipName(item.equipInfo, item.equipInfo.type)"> </span>
              </CommonBtn>
            </template>
            <EquipInfo :equip-info="item.equipInfo" :show-action="false" />
          </el-popover>
        </template>
        <div class="lock overlay" v-show="dayjs().diff(dayjs(userStore.created).format('YYYY-MM-DD 00:00:00'), 'day') < index">
          <el-icon><Lock /></el-icon>
        </div>
        <div class="check overlay" v-show="userStore.noviceCheckInIndex > index">
          <el-icon><CircleCheck /></el-icon>
        </div>
      </div>
    </div>
    <el-button type="success" plain style="width: 100%" @click="handleReceive" :disabled="!canReceive">{{
      canReceive ? '领取' : '静候时日'
    }}</el-button>
  </div>
</template>

<style lang="scss" scoped>
.novice-check-in {
  .reward {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .border-wrap {
      width: calc(33.33% - 5px);
      padding: 10px;
      margin-bottom: 10px;
      position: relative;
      h3 {
        font-size: 16px;
        text-align: left;
        margin: 0 0 10px 0;
      }
      .common-btn-wrap {
        text-align: left;
        width: 100%;
        :deep(button) {
          width: 100%;
        }
      }
      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba($color: #fff, $alpha: 0.1);
        pointer-events: none;
        i {
          font-size: 20px;
        }
        &.lock {
          i {
            color: #f05654;
          }
        }
        &.check {
          i {
            color: #3eb370;
          }
        }
      }
    }
  }
  :deep() {
    .el-button:focus,
    .el-button:hover {
      background-color: unset;
    }
  }
}
</style>
